<script setup>
import { computed } from 'vue';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import { useDateLocale } from 'dashboard/composables/useDateLocale';
import ThreadEvent from 'next/polaris/cards/ThreadEvent.vue';
import { useMessageContext } from '../provider.js';

const { content, createdAt } = useMessageContext();

const dateLocale = useDateLocale();
const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, h:mm a', dateLocale.value)
);
</script>

<template>
  <!-- The activity text does not say who did it in a way the app can read, so
       every event is the kit's system event (actor "system"). -->
  <ThreadEvent v-tooltip.top="readableTime" data-bubble-name="activity">
    <span v-dompurify-html="content" :title="content" />
  </ThreadEvent>
</template>
